;
export var translations = {
    Sounds: 'Sounds',
    Sound: 'Sound',
    Drive: 'Drive',
    Drives: 'Drives'
};
export function setTranslations(m) {
    Object.keys(m).forEach(function (key) {
        translations[key] = m[key];
    });
}
//# sourceMappingURL=translations.js.map